import React from 'react';
import {Navbar} from '../../../components';
import {FluidContainer, TablePlayerHealth} from '../../../components';
import {TableWrapper} from '../../players/styles';
import {LabelsContainer, LabelsWrapper, TextContainer, AlertContainer, Oval} from '../styles';

export default () => (
  <>
    <Navbar />
    <FluidContainer>
      <LabelsWrapper>
        <LabelsContainer>
          <TextContainer>WELLNESS SCALE</TextContainer>
          <AlertContainer>
            <Oval size={'8'} color={'green'} />
            <span> Normal</span>
          </AlertContainer>
          <AlertContainer>
            <Oval size={'8'} color={'yellow'} />
            <span> Caution</span>
          </AlertContainer>
          <AlertContainer>
            <Oval size={'8'} color={'red'} />
            <span> Poor</span>
          </AlertContainer>
        </LabelsContainer>
      </LabelsWrapper>
      <TableWrapper>
        <TablePlayerHealth dataTableContent={[]} />
      </TableWrapper>
    </FluidContainer>
  </>
);
